import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ESLogo from "../components/logo/esLogo";
import AuthContext from "../store/authContext";

const SSOLogin = () => {
  const { isLoggedIn, authenticateWithToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSSOAuthentication = async () => {
    // Extract token from URL
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get("token");
    if (!token) {
      console.error("No authentication token provided");
    } else {
      try {
        const success = authenticateWithToken(token, "yes", "1000");
        if (success) {
          // If authentication was successful, redirect to dashboard
          navigate("/overview");
        } else {
          console.error("Invalid or expired authentication token");
        }
      } catch (err) {
        console.error("SSO authentication error:", err);
      }
    }
  };

  useEffect(() => {
    // Only try to authenticate if not already authenticated
    if (!isLoggedIn) {
      handleSSOAuthentication();
    } else {
      // If already authenticated, just go to dashboard
      navigate("/overview", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);
  return (
    <div className="login-screen">
      <ESLogo />
      <div className="flex justify-center w-screen items-center bg-white pt-60">
        <div className="w-full login-form-wrapper flex flex-col items-center ">
          <div className="login-header w-full">
            <h1 className="mb-0 text-center" data-cy="login-heading">
              Not Authorised
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SSOLogin;
